/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditPoolServerStats {
    getFixupPrototypeFunction() { return RequestAuditPoolServerStats.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditPoolServerStats>): RequestAuditPoolServerStats {
        let obj = Object.assign(new RequestAuditPoolServerStats(), model);
        RequestAuditPoolServerStats.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditPoolServerStats>): RequestAuditPoolServerStats {
        if (!model) return null;
        return RequestAuditPoolServerStats.newInstance(<RequestAuditPoolServerStats> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditPoolServerStats) {
        if (!obj) return;

        models.RequestAuditPoolServerStats.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditPoolServerStats): boolean {
        Object.setPrototypeOf(obj, RequestAuditPoolServerStats.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.active === undefined) {
            this.active = 0;
        }
        if (this.idle === undefined) {
            this.idle = 0;
        }
        if (this.waiting === undefined) {
            this.waiting = 0;
        }
    }

    /**
     * Server address (host:port).
     */
    address: string;

    /**
     * Connections checked out by application threads.
     */
    active: number;

    /**
     * Idle connections in the pool.
     */
    idle: number;

    /**
     * Threads waiting for a connection.
     */
    waiting: number;

}
